<template>
	<div>
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="large"
            @close="close"
			>
            <template slot="header">
                <h5 class="mb-0">{{ $t('Promo Code list on') }} {{promoName}}</h5>
            </template>
            <template slot="body">
				<div class="table-menu flex-center">
					<div>
						<button
							class="btn btn-submit btn-default"
							@click="addItem">
							{{ $t('Add Code') }}
						</button>
					</div>
				</div>
				<!-- Loader -->
				<div class="p-5 text-center" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<!-- main List -->
				<div id="styleScroll2" class="list-group list-feature-wrapper">
					<draggable v-model="promoCodes" @change="onListChange" v-if="promoCodes.length > 0" v-bind="dragOptions">
						<transition-group type="transition">
							<div v-for="item in promoCodes" :key="item.id">
								<div @click="editItem(item)">
									<a class="list-group-item text-decoration-none pointer">
										<div class="d-flex justify-content-between">
											<div class="d-flex"><h5 class="mr-1">CODE:</h5><h5 class="text-primary">{{ item.code }}</h5></div>
											<div class="d-flex">
												<div @click.stop="activateCode(item)">
													<mdIcon class="feature-icon-edit-active" v-tooltip="'Active'" v-if="item.is_active">check_circle_outline</mdIcon>
													<mdIcon class="feature-icon-edit" v-tooltip="'Non Active'" v-if="!item.is_active">check_circle_outline</mdIcon>
												</div>
												<div @click="editItem(item)">
													<mdIcon class="feature-icon-edit" v-tooltip="'Edit'">edit</mdIcon>
												</div>
												<div @click.stop="confirmRemoveItem(item)">
													<mdIcon  class="feature-icon-delete" v-tooltip="'Delete'">cancel</mdIcon>
												</div>
											</div>
										</div>
										<div>
											<label v-if="item.is_active" class="text-secondary mr-1">{{ $t('This Promo Code is') }}</label><span v-if="item.is_active" class="text-primary">active</span>
											<label v-if="!item.is_active" class="text-secondary mr-1">{{ $t('This Promo Code is') }} </label><span v-if="!item.is_active" class="text-primary">non active</span>
											<label v-if="item.is_default_promo" class="text-secondary mr-1 ml-2">({{ $t('Default Promo') }}) </label>
										</div>
									</a>
								</div>
							</div>
						</transition-group>
					</draggable>
					<div v-if="!isFetching && promoCodes.length === 0" class="text-center">
						{{ $t('You have not added any promo code yet') }}
					</div>
				</div>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
		<!-- Modals -->
		<div class="modals">
			<!-- Code Promos Form -->
			<promo-code-form
				:data="selected"
				:dataPromo="dataPromo"
				@saved="insertItem"
				@fetch="fetch"
				@close="closeModalPromo"
				v-if="isPromoFormVisible || isNewPromo"
			/>
			<!-- Delete Confirmation -->
			<modal
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					<h3>{{ $t('Remove Promo Code') }}</h3>
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ selected.code }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>

import draggable from 'vuedraggable';
import Modal from '@/components/Modal.vue';
import PromoCodeForm from '@/components/PromoCodeForm.vue';
import promoCodesApi from '@/api/promoCode';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'ModalPromoCodeList',
	components: {
		Modal,
		draggable,
		PromoCodeForm,
	},
	props: {
		dataPromo: {
			type: Object,
		},
		isNewPromo: {
			type: Boolean,
		},
	},
	mounted() {
	},
	data: () => ({
		dragOptions: {
			animation: 100,
		},
		drag: false,
		code: '',
		promoCodes: [],
		selected: null,
		isPromoFormVisible: false,
		isConfirmRemoveVisible: false,
		isRemoving: false,
		isFetching: false,
	}),
	methods: {
		close() {
			this.$emit('close');
		},
		initDataPromo() {
			this.resetDataPromo();
			if (this.dataPromo) {
				this.setDataPromo(this.dataPromo);
			}
		},
		resetDataPromo() {
			this.promoName = '';
		},
		setDataPromo(dataPromo) {
			this.promoName = dataPromo.name;
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.promoCodes = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.promoCodes = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Promos',
					text: message,
				});
				this.isFetching = false;
			};
			promoCodesApi.getList(params, callback, errorCallback);
		},

		insertItem(item) {
			const index = this.promoCodes.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.promoCodes.push(item);
				this.$emit('resetNewPromo');
			} else {
				this.$set(this.promoCodes, index, item);
			}
		},
		closeModalPromo() {
			this.$emit('resetNewPromo');
			this.isPromoFormVisible = false;
		},
		addItem() {
			this.selected = null;
			this.isPromoFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isPromoFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.promoCodes.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.promoCodes.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Promos',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Promos',
					text: message,
				});
			};
			promoCodesApi.delete(item.id, callback, errorCallback);
		},
		onListChange() {
			this.promoCodes.forEach((item, index) => {
				const order = index + 1;
				this.$set(this.promoCodes[index], 'order', order);
			});
			const ids = this.promoCodes.map(({ id }) => id);
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'Notification',
					type: 'success',
					title: this.$t('Promos Items'),
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'Notification',
					type: 'error',
					title: this.$t('Error'),
					text: message,
				});
			};
			promoCodesApi.reOrder(ids, callback, errorCallback);
		},
		activateCode(item) {
			const params = {
				is_active: !item.is_active,
			};
			const callback = (response) => {
				const promo = response.data;
				const message = response.message;
				this.insertItem(promo);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Promo',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Promo',
					text: message,
				});
			};
			promoCodesApi.update(item.id, params, callback, errorCallback);
		},
	},
	computed: {
		fetchParams() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				promo_id: this.dataPromo.id,
				// role: this.role,
			};
			return params;
		},
	},
	created() {
		this.initDataPromo();
		this.fetch(true);
	},
};
</script>
